import { useEffect, useState } from "react";
import { X } from "lucide-react";

import { callApi, formatDT } from "./utils";

const formatFileSize = (sizeBytes) => {
  if (sizeBytes == null) return "—";
  if (sizeBytes < 1024) return `${sizeBytes} Б`;
  if (sizeBytes < 1024 * 1024) return `${(sizeBytes / 1024).toFixed(1)} КБ`;
  return `${(sizeBytes / (1024 * 1024)).toFixed(1)} МБ`;
};

export default function VersionHistory({ apiPath, apiQueryParams, onCancel }) {
  const [versions, setVersions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");

    callApi({
      method: "GET",
      path: apiPath,
      queryParams: new URLSearchParams(apiQueryParams),
      needAuth: true,
    })
      .then((response) => {
        setIsLoading(false);

        const err = response.error;
        if (err) {
          setError(response.message || "Не удалось загрузить историю версий.");
        } else {
          const respArr = response.response;
          if (respArr) {
            setVersions(respArr);
          }
        }
      })
      .catch(() => setIsLoading(false));
  }, []);

  const renderBody = () => {
    if (isLoading) {
      return <p className="muted">Загрузка истории...</p>;
    }

    if (error) {
      return <p className="warning">{error}</p>;
    }

    if (!versions.length) {
      return <p className="muted">История версий пуста.</p>;
    }

    return (
      <div className="version-history-list">
        {versions.map((version) => (
          <article className="version-history-entry" key={version.id}>
            <div className="version-history-heading">
              <strong>Версия {version.versionNo}</strong>
              <span className="version-history-state">
                {version.stateLabel || version.state || "—"}
              </span>
            </div>
            <dl className="version-history-details">
              <div>
                <dt>Размещено</dt>
                <dd>{formatDT(version.postedAt) || "—"}</dd>
              </div>
              <div>
                <dt>Студент</dt>
                <dd>{version.authorName || "—"}</dd>
              </div>
              <div>
                <dt>Имя файла</dt>
                <dd>{version.fileName || "—"}</dd>
              </div>
              <div>
                <dt>Размер</dt>
                <dd>{formatFileSize(version.sizeBytes)}</dd>
              </div>
            </dl>
            {version.afterDeadline && (
              <div className="version-after-deadline">
                Размещена после даты завершения
              </div>
            )}
          </article>
        ))}
      </div>
    );
  };

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal version-history-modal">
        <div className="modal-head">
          <h2>История версий</h2>
          <button className="icon-btn" onClick={onCancel} aria-label="Закрыть">
            <X size={18} />
          </button>
        </div>
        <div className="modal-body">{renderBody()}</div>
        <div className="modal-foot">
          <button className="btn ghost" onClick={onCancel}>
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}
